module.exports = __webpack_public_path__ + "img/info-region.fda3570f.svg";